<template>
  <div class="echarts">
    <div class="top item" style="height:180px">
      <div class="title">
          <h4>数据统计</h4>
           <div>
              <el-date-picker
                v-model="dateVal"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                 @change="dateChange"
              ></el-date-picker>
            </div>
      </div>
      <div class="box box1">
        <div class="box1item" style="background:#5087EC">
          <div class="da">{{tongji.total?tongji.total:0}}</div>
          <div class="xiao">累计开通量</div>
        </div>
        <div class="box1item" style="background:#F2BD42">
          <div class="da">{{tongji.incremental?tongji.incremental:0}}</div>
          <div class="xiao">新增开通量</div>
        </div>
        <div class="box1item" style="background:#58A55C">
          <div class="da">{{tongji.active?tongji.active:0}}</div>
          <div class="xiao">活跃货主量</div>
        </div>
        <div class="box1item" style="background:#68BBC4">
          <div class="da">{{tongji.notActive?tongji.notActive:0}}</div>
          <div class="xiao">非活跃货主量</div>
        </div>
      </div>
    </div>
    <div class="center item" style="height:400px">
      <div class="title">
          <h4>货主数据列</h4>
      </div>
      <div class="box">
        <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"   style="width: 100%" height="100%"  center border>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column prop="socName"  min-width="200" :formatter="emptyFn" label="货主名称"></el-table-column>
        <el-table-column prop="accountNumber"  width="120" :formatter="emptyFn" label="账号数量"></el-table-column>
        <el-table-column prop="loginNumber"  sortable width="120" :formatter="emptyFn" label="登录次数"></el-table-column>
        <el-table-column prop="pickGoodsNum" sortable  width="120" :formatter="emptyFn" label="提货次数"></el-table-column>
        <el-table-column prop="transferGoodsNum"  sortable width="120" :formatter="emptyFn" label="转货次数"></el-table-column>
        <el-table-column prop="openTime" width="170" :formatter="dateTimeFormat"  label="开通时间"></el-table-column>
        <el-table-column prop="lastLoginTime" width="170" :formatter="dateTimeFormat"  label="最后登陆时间"></el-table-column>
      </el-table>
      </div>
    </div>
     <div class="item" style="height:400px;">
        <div class="title">
            <h4>新增货主趋势</h4>
        </div>
        <div class="box" id="zhe"></div>
    </div>
    <!-- <div class="item" style="height:400px">
       <div class="title">
            <h4>货主活跃度对比</h4>
        </div>
        <div class="box"  id="zhu"></div>
    </div> -->
    <!-- <div class="bottom" style="height:500px">
      <div class="left">

      </div>
      <div class="right">

      </div>
    </div> -->
  </div>
</template>

<script>
import { socActiveList, activeStatistical, getMonthStatistics, listStatistics } from '@/api/data-center-server'
import { emptyFn, dateTimeFormat } from '@/utils/util'
export default {
  data () {
    return {
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      loading: false,
      tableList: [],
      dateVal: null,
      tongji: {}

    }
  },
  created () {
    this.getList()
  },
  mounted () {
    function timestampToTime (tiem) {
      var date = new Date(tiem)// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      return Y + M + D
    };
    let startDatr = timestampToTime(new Date().getTime() - 1000 * 60 * 60 * 24 * 30)
    let endDate = timestampToTime(new Date().getTime())
    this.dateVal = [startDatr, endDate]
    activeStatistical({ createTimes: this.dateVal }).then(res => {
      this.tongji = res
    })
    this.zheFn()
    // this.zhuFn()
  },
  methods: {
    dateChange () {
      activeStatistical({ createTimes: this.dateVal }).then(res => {
        this.tongji = res
      })
    },
    // 货主新增趋势
    zheFn () {
      getMonthStatistics({}).then(res => {
        let dateNames = []
        let valueArr = []
        res.forEach((item, index) => {
          dateNames.push(item.date)
          valueArr.push(item.num)
        })
        let _this = this
        let idChart = _this.$echarts.init(document.getElementById('zhe'))
        // 绘制图表--折线图
        var idChartOption = {
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: ['原卷重量', '成品重量'],
            color: ['#fff'],
            textStyle: {
              color: '#fff'
            }
          },
          grid: {
            left: '6%',
            right: '8%',
            bottom: '9%',
            top: '10%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: dateNames,
            // 横坐标轴颜色
            axisLine: {
              lineStyle: {
                // color: '#14D5FF'
              }
            },
            axisLabel: {
              interval: 0,
              rotate: 60,
              textStyle: {
                fontFamily: 'Microsoft YaHei'
              }
            }
          },
          yAxis: {
            name: '新增货主',
            type: 'value'
            // // 横坐标轴颜色
            // axisLine: {
            //   lineStyle: {
            //     color: '#14D5FF'
            //   }
            // },
            // splitLine: {
            //   lineStyle: {
            //     color: '#14D5FF'
            //   }
            // }
          },
          series: [
            {
              name: '新增货主',
              type: 'line',
              color: '#E09C13',
              data: valueArr
            }
          ]
        }
        idChart.setOption(idChartOption)
      })
    },
    // 货主活跃度对比
    // zhuFn () {
    //   socActiveList().then(res => {
    //     let dateNames = []
    //     let valueArr = []
    //     res.forEach((item, index) => {
    //       if (item.loginNumber > 0) {
    //         dateNames.push(item.socName)
    //         valueArr.push(item.loginNumber)
    //       }
    //     })
    //     let myChart = this.$echarts.init(document.getElementById('zhu'))
    //     let option = {
    //       color: ['#0DD9FE', '#52F23A', '#FFAF03', '#ff5b00', '#ff0'],
    //       // backgroundColor: "#323a5e",
    //       grid: {
    //         left: '6%',
    //         right: '4%',
    //         bottom: '9%',
    //         top: '10%',
    //         containLabel: true
    //       },
    //       tooltip: {
    //         trigger: 'axis'
    //       },
    //       xAxis: {
    //         type: 'category',
    //         data: dateNames,
    //         axisLabel: {
    //           interval: 0,
    //           rotate: 20,
    //           textStyle: {
    //             fontFamily: 'Microsoft YaHei'
    //           }
    //         }
    //       },
    //       yAxis: {
    //         name: '货主登陆次数',
    //         type: 'value'
    //       },
    //       dataZoom: [
    //         {
    //           type: 'slider',
    //           show: true,
    //           start: 0,
    //           end: 40,
    //           handleSize: 8
    //         },
    //         {
    //           type: 'inside',
    //           start: 94,
    //           end: 100
    //         }
    //       ],
    //       series: [
    //         {
    //           data: valueArr,
    //           type: 'bar',
    //           showBackground: true
    //         }
    //       ]
    //     }
    //     option && myChart.setOption(option)
    //   }).catch(err => {
    //     console.log(err)
    //   })
    // },
    // 货物数据列
    getList () {
      this.loading = true
      socActiveList({ }).then(res => {
        this.loading = false
        this.tableList = res
      })
    }
  }

}
</script>

<style scoped lang='less'>
.box1{
  display: flex;
  justify-content: space-around;
  .box1item{
    width: 18%;
    height: 90%;
    border-radius: 4px;
    color: #fff;
    display: flex;
    flex-direction:column ;
    justify-content: center;
    text-align: center;
    .da{
      font-size: 48px;
    }
    .xiao{
      font-size: 14px;
    }
  }
}
.echarts{
    background: #E5E5E5;
    padding: 10px 10px 10px 0;
    box-sizing: border-box;
    width:100%;
    margin-top: -12px;
    .item{
      background: #fff;
      margin-bottom:8px;
    }
    .title{
      display: flex;
      justify-content: space-between;
      padding: 0 10px;
       height: 40px;
      align-items: center;
      h4{
        margin: 0;
        font-size: 16px;
        padding: 0;
        border-left: 3px solid #0e6fec;
        padding-left: 10px;
      }
      /deep/.el-input__inner{
          border:none;
          width: 260px;
        }
    }
    .box{
      height:calc(100% - 40px);
    }
   .bottom{
     display: flex;
     .left{
       width: 50%;
       margin-right: 8px;
       background: #fff;
     }
     .right{
        width: 50%;
       background: #fff;
     }

   }
}
</style>
